import styled from 'styled-components'

import { FileActionContainerStyled } from '../../FileActionContainer/styles/FileActionContainerStyled'
import { UploadFileStyled } from '../../UploadFile/styles/UploadFileStyled'
import { MediaStyled } from '@ui/elements/Media/styles/MediaStyled'

interface IUploadFileContainerStyledProps {}

export const UploadFileContainerStyled = styled.div<IUploadFileContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  position: relative;

  padding: 0.5em 1em;

  & + & {
    border-top: 1px solid ${(props) => props.theme.colors.content.border};
  }

  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  ${MediaStyled} {
    cursor: zoom-in;
  }

  ${UploadFileStyled} {
    flex: 1 0;
  }

  ${FileActionContainerStyled} {
    flex: 0 1;
  }
`
